var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-investment-info-group"},[_c('chart-boxes-container',{attrs:{"data":_vm.chartsData,"tabs":_vm.tabs}}),_c('investment-info-boxes-container',{attrs:{"data":_vm.investmentInfoData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }